import React, { ReactElement } from 'react'

import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import {
  createPlanningCourseV2Instructor,
  fetchCourseV2Compliances,
  fetchPlanningCourseV2Details,
  fetchPlanningCourseV2AvailableInstructors,
  selectPlanningCourseV2AvailableInstructors,
  selectPlanningCourseV2AvailableInstructorsStatus,
  selectPlanningCourseV2InstructorsSaveStatusByCourseID,
  updatePlanningCourseV2Instructor,
  updatePlanningCourseV2Instructors,
} from 'src/v3/content-pipeline/course-pipeline.slice'
import { ContentComplianceStatus, Instructor } from 'src/v3/core/types'
import InstructorsManagement from 'src/v3/content-pipeline/components/instructors-management'

type Props = {
  courseID: string
  instructors?: Instructor[]
  complianceStatus?: ContentComplianceStatus
  complianceFeedback?: string
}

export default function CourseInstructorsManagement({
  courseID,
  instructors = [],
  complianceStatus,
  complianceFeedback,
}: Props): ReactElement {
  let dispatch = useAppDispatch()
  let availableInstructors = useAppSelector(
    selectPlanningCourseV2AvailableInstructors,
  )
  let availableInstructorsStatus = useAppSelector(
    selectPlanningCourseV2AvailableInstructorsStatus,
  )
  let saveStatus = useAppSelector(
    selectPlanningCourseV2InstructorsSaveStatusByCourseID(courseID),
  )

  return (
    <InstructorsManagement
      droppableId={`course-${courseID}-instructors`}
      instructors={instructors}
      complianceStatus={complianceStatus}
      complianceFeedback={complianceFeedback}
      availableInstructors={availableInstructors}
      availableInstructorsStatus={availableInstructorsStatus}
      saveStatus={saveStatus}
      onFetchAvailableInstructors={() =>
        dispatch(fetchPlanningCourseV2AvailableInstructors())
      }
      onSave={(instructorIds) =>
        dispatch(
          updatePlanningCourseV2Instructors({
            courseId: courseID,
            instructors: instructorIds,
          }),
        )
      }
      onSaved={() => dispatch(fetchCourseV2Compliances())}
      onCreateInstructor={async (payload) => {
        // eslint-disable-next-line no-restricted-syntax -- TODO(ENG-694): pre-existing await dispatch/.unwrap() pattern; refactor to selector-driven state
        let result = await dispatch(createPlanningCourseV2Instructor(payload))
        if (!createPlanningCourseV2Instructor.fulfilled.match(result)) {
          return Promise.reject(new Error('Failed to create instructor'))
        }
        return result.payload
      }}
      onUpdateInstructor={async (instructorId, payload) => {
        // eslint-disable-next-line no-restricted-syntax -- TODO(ENG-694): pre-existing await dispatch/.unwrap() pattern; refactor to selector-driven state
        let result = await dispatch(
          updatePlanningCourseV2Instructor({ instructorId, payload }),
        )
        if (!updatePlanningCourseV2Instructor.fulfilled.match(result)) {
          return Promise.reject(new Error('Failed to update instructor'))
        }
        dispatch(fetchPlanningCourseV2Details(courseID))
        dispatch(fetchCourseV2Compliances())
        return result.payload
      }}
    />
  )
}
